// Mensajes y WhatsApp: qué se le manda solo al cliente (correo y WhatsApp),
// la conexión del número de la empresa y quiénes del equipo manejan el
// sistema escribiéndole a ese número.
import { el, clear } from '../../utils/dom.js';
import { Rentals, Settings, Users } from '../../api/resources.js';
import { field, readForm } from '../../components/form.js';
import { ok, err, info } from '../../components/toast.js';
import { confirm } from '../../components/modal.js';

const ESTADO = { pendiente: 'En cola', enviando: 'Enviando', enviado: 'Enviado', fallido: 'Falló', omitido: 'No salió' };
const COLOR = { enviado: 'success', fallido: 'danger', omitido: 'muted', pendiente: 'warning', enviando: 'warning' };
const fmt = (iso) => new Intl.DateTimeFormat('es-DO', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone: 'America/Santo_Domingo' }).format(new Date(iso));

let sdk = null;
function cargarSdk(appId) {
  if (sdk) return sdk;
  sdk = new Promise((resolve, reject) => {
    if (window.FB) { resolve(); return; }
    window.fbAsyncInit = () => { window.FB.init({ appId, autoLogAppEvents: true, xfbml: false, version: 'v26.0' }); resolve(); };
    const s = el('script', { id: 'facebook-jssdk', src: 'https://connect.facebook.net/es_LA/sdk.js', async: true, defer: true, crossorigin: 'anonymous' });
    s.onerror = () => { sdk = null; reject(new Error('No se pudo cargar Meta')); };
    document.body.appendChild(s);
  });
  return sdk;
}

export default async function MensajesPage(outlet) {
  clear(outlet);
  let cfg; let usuarios = [];
  try {
    [cfg, usuarios] = await Promise.all([Rentals.mensajesConfig(), Users.list({ limit: 200 }).then((r) => r.data || []).catch(() => [])]);
  } catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }
  const a = cfg.ajustes;
  const recargar = () => MensajesPage(outlet);

  outlet.appendChild(el('div', { class: 'page-head' },
    el('div', {}, el('h1', {}, 'Mensajes y WhatsApp'), el('div', { class: 'muted' }, 'Lo que le llega solo al cliente y cómo manejas todo desde WhatsApp')),
    el('a', { href: '#/rentals/ajustes', class: 'btn ghost' }, '← Ajustes de rentas')));

  if (cfg.seco) outlet.appendChild(el('div', { class: 'card mb-4 msg-aviso' }, '⚠️ Este servidor está en modo seco: los mensajes se preparan pero no salen.'));

  // ------------------------------------------------ al cliente
  const apagados = new Set(a.apagados || []);
  const formCliente = el('form', { onsubmit: async (e) => {
    e.preventDefault();
    const d = readForm(formCliente);
    const off = cfg.eventos.filter((ev) => !formCliente.querySelector(`input[name="ev_${ev.id}"]`).checked).map((ev) => ev.id);
    const prueba = d.prueba_activa ? { email: (d.prueba_email || '').trim(), telefono: (d.prueba_tel || '').trim() } : null;
    try {
      await Settings.bulk({
        'mensajes.email_activo': { value: !!d.email_activo, description: 'Mandar correos automáticos a los clientes' },
        'mensajes.whatsapp_activo': { value: !!d.wa_activo, description: 'Mandar WhatsApp automáticos a los clientes' },
        'mensajes.apagados': { value: off, description: 'Mensajes que NO se mandan (lista de eventos)' },
        'mensajes.prueba': { value: prueba && (prueba.email || prueba.telefono) ? prueba : null, description: 'Modo prueba: todo va a este correo/teléfono en vez del cliente' },
        'company.email': { value: (d.empresa_email || '').trim(), description: 'Correo de la empresa (los clientes responden aquí)' },
        'company.phone': { value: (d.empresa_tel || '').trim(), description: 'Teléfono de la empresa' },
      });
      ok('Guardado'); recargar();
    } catch (ex) { err(ex.message); }
  } },
  el('section', { class: 'card mb-4' },
    el('h3', { class: 'rp-h' }, 'Mensajes al cliente'),
    el('p', { class: 'muted text-sm' }, 'En cada paso de la renta el cliente recibe un correo y/o un WhatsApp con el enlace a su renta (resumen, factura, pagos y contrato).'),
    el('div', { class: 'form-grid' },
      field({ name: 'empresa_email', label: 'Correo de la empresa (ahí te responden)', type: 'email', value: a.email, placeholder: 'ventas@tuempresa.com' }),
      field({ name: 'empresa_tel', label: 'Teléfono de la empresa', value: a.telefono, placeholder: '809 555 1234' })),
    field({ name: 'email_activo', label: `Mandar correos${cfg.correo_listo ? '' : ' (el correo del servidor no está listo)'}`, type: 'checkbox', value: a.email_activo }),
    field({ name: 'wa_activo', label: `Mandar WhatsApp${cfg.whatsapp.conectado ? '' : ' (primero conecta el número abajo)'}`, type: 'checkbox', value: a.whatsapp_activo }),
    el('p', { class: 'rp-sub mt-3' }, 'Qué mensajes se mandan'),
    el('div', { class: 'msg-eventos' }, ...cfg.eventos.map((ev) => field({ name: `ev_${ev.id}`, label: ev.nombre, type: 'checkbox', value: !apagados.has(ev.id) }))),
    el('p', { class: 'rp-sub mt-3' }, 'Modo prueba'),
    el('p', { class: 'muted text-sm' }, 'Mientras está encendido, TODO lo que iría a los clientes llega a este correo y a este WhatsApp.'),
    field({ name: 'prueba_activa', label: 'Modo prueba encendido', type: 'checkbox', value: !!a.prueba }),
    el('div', { class: 'form-grid' },
      field({ name: 'prueba_email', label: 'Correo de prueba', type: 'email', value: a.prueba?.email || '' }),
      field({ name: 'prueba_tel', label: 'WhatsApp de prueba', value: a.prueba?.telefono || '', placeholder: '809 555 1234' })),
    el('button', { class: 'btn primary mt-3', type: 'submit' }, 'Guardar')));
  outlet.appendChild(formCliente);

  // ------------------------------------------------ conexión de WhatsApp
  const w = cfg.whatsapp;
  const secWa = el('section', { class: 'card mb-4' }, el('h3', { class: 'rp-h' }, 'WhatsApp de la empresa'));
  if (!w.plataforma_lista) secWa.appendChild(el('p', { class: 'text-sm msg-aviso' }, 'Falta la llave de WhatsApp de la plataforma en el servidor. Avísale a soporte.'));
  if (w.conectado) {
    const ya = new Map((cfg.plantillas || []).map((t) => [t.name, t]));
    const faltan = cfg.plantillas_necesarias.filter((n) => !ya.has(n));
    const aprobadas = cfg.plantillas_necesarias.filter((n) => ya.get(n)?.status === 'APPROVED').length;
    secWa.append(
      el('p', {}, '✅ Conectado: ', el('strong', {}, w.numero || ''), w.nombre ? ` · ${w.nombre}` : ''),
      el('p', { class: 'muted text-sm' }, `Cuenta de WhatsApp ${w.waba_id} (de tu portafolio de Meta) · ${w.cuenta_propia ? 'con tu propia app de Meta' : 'enlazada a la app de la plataforma'}. Los mensajes se cobran a tu cuenta de WhatsApp.`),
      el('p', { class: 'rp-sub mt-3' }, `Plantillas de Meta (${aprobadas} de ${cfg.plantillas_necesarias.length} aprobadas)`),
      el('p', { class: 'muted text-sm' }, 'Meta debe aprobar estos mensajes una vez para poder escribirle a un cliente que no te ha escrito hoy. Tarda de minutos a 1 día.'),
      el('ul', { class: 'msg-plantillas' }, ...cfg.plantillas_necesarias.map((n) => {
        const t = ya.get(n);
        const st = t ? t.status : 'NO CREADA';
        return el('li', {}, el('code', {}, n), ' ', el('span', { class: `badge ${st === 'APPROVED' ? 'success' : st === 'REJECTED' ? 'danger' : 'warning'}` },
          { APPROVED: 'aprobada', PENDING: 'en revisión', REJECTED: 'rechazada', 'NO CREADA': 'sin crear' }[st] || st.toLowerCase()),
        t?.rejected_reason && t.rejected_reason !== 'NONE' ? el('span', { class: 'muted text-sm' }, ` ${t.rejected_reason}`) : null);
      })),
      el('div', { class: 'flex gap-2 wrap mt-2' },
        faltan.length ? el('button', { class: 'btn primary', type: 'button', onclick: async (e) => {
          e.target.disabled = true;
          try {
            const r = await Rentals.crearPlantillas();
            const malas = r.filter((x) => !x.ok);
            if (malas.length) err(malas.map((x) => `${x.name}: ${x.error}`).join(' · ')); else ok('Plantillas enviadas a Meta para aprobar');
            recargar();
          } catch (ex) { err(ex.message); e.target.disabled = false; }
        } }, `Crear ${faltan.length} plantilla${faltan.length === 1 ? '' : 's'}`) : null,
        el('button', { class: 'btn ghost', type: 'button', onclick: async () => {
          if (!(await confirm({ title: 'Desconectar WhatsApp', message: 'Dejan de salir los WhatsApp automáticos y el equipo ya no podrá manejar el sistema por WhatsApp. Tu WhatsApp Business del celular sigue igual.', confirmText: 'Desconectar', danger: true }))) return;
          try { await Rentals.desconectarWa(); ok('Desconectado'); recargar(); } catch (ex) { err(ex.message); }
        } }, 'Desconectar')));
  } else {
    secWa.append(
      el('p', { class: 'muted text-sm' }, 'Conecta el número de WhatsApp Business de tu empresa. Todo queda a tu nombre: tu portafolio de negocio de Meta, tu cuenta de WhatsApp y tu número (si no tienes portafolio, Meta te deja crearlo ahí mismo). Lo sigues usando en tu celular como siempre; además el sistema podrá mandar los mensajes y atender al equipo.'),
      el('ol', { class: 'text-sm msg-pasos' },
        el('li', {}, 'Ten a mano el celular con WhatsApp Business de la empresa.'),
        el('li', {}, 'Toca "Conectar con Meta", entra con el Facebook del negocio y elige "Conectar mi app de WhatsApp Business".'),
        el('li', {}, 'Escanea el código QR que te muestra Meta desde WhatsApp Business (Ajustes → Dispositivos vinculados).')));
    const conectar = el('button', { class: 'btn primary', type: 'button', disabled: !(cfg.meta.app_id && cfg.meta.config_id && w.plataforma_lista) }, 'Conectar con Meta');
    conectar.onclick = () => {
      if (!window.FB) { info('Meta todavía está cargando. Toca otra vez en un segundo.'); cargarSdk(cfg.meta.app_id).catch(() => null); return; }
      conectar.disabled = true;
      window.FB.login((r) => { if (r && r.status && r.status !== 'connected') { conectar.disabled = false; info('Meta cerró la ventana sin terminar.'); } },
        { config_id: cfg.meta.config_id, response_type: 'code', override_default_response_type: true, extras: {} });
    };
    // Meta avisa por postMessage cuando termina.
    const onMsg = async (ev) => {
      if (typeof ev.origin !== 'string' || !ev.origin.endsWith('facebook.com')) return;
      let d; try { d = typeof ev.data === 'string' ? JSON.parse(ev.data) : ev.data; } catch { return; }
      if (!d || d.type !== 'WA_EMBEDDED_SIGNUP') return;
      if (['FINISH', 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING', 'FINISH_ONLY_WABA'].includes(d.event)) {
        window.removeEventListener('message', onMsg);
        try { await Rentals.conectarWa({ waba_id: String(d.data?.waba_id || ''), phone_number_id: d.data?.phone_number_id ? String(d.data.phone_number_id) : null }); ok('WhatsApp conectado'); recargar(); }
        catch (ex) { err(ex.message); conectar.disabled = false; }
      } else if (d.event === 'CANCEL') { conectar.disabled = false; info('No se terminó el enlace. Puedes intentarlo otra vez.'); }
      else if (d.event === 'ERROR') { conectar.disabled = false; err(String(d.data?.error_message || 'Meta devolvió un error')); }
    };
    window.addEventListener('message', onMsg);
    if (cfg.meta.app_id) cargarSdk(cfg.meta.app_id).catch(() => null);

    // A mano (soporte): con los números de la cuenta de Meta.
    const manual = el('form', { class: 'form-grid mt-3', onsubmit: async (e) => {
      e.preventDefault();
      const d = readForm(manual);
      try { await Rentals.conectarWa({ waba_id: (d.waba_id || '').trim(), phone_number_id: (d.phone_number_id || '').trim() || null, token: (d.token || '').trim() || null }); ok('WhatsApp conectado'); recargar(); }
      catch (ex) { err(ex.message); }
    } },
    field({ name: 'waba_id', label: 'ID de la cuenta de WhatsApp (WABA)', placeholder: '1234567890', required: true }),
    field({ name: 'phone_number_id', label: 'ID del número (opcional)', placeholder: '1234567890' }),
    field({ name: 'token', label: 'Token de tu propia app de Meta (opcional)', type: 'password', autocomplete: 'off', full: true,
      hint: 'Solo si usas tu propia app de Meta: token permanente de un usuario del sistema de TU portafolio, con permisos whatsapp_business_management y whatsapp_business_messaging. Vacío = se usa la app de la plataforma.' }),
    el('div', { class: 'field' }, el('label', {}, ' '), el('button', { class: 'btn', type: 'submit' }, 'Conectar con estos datos')));
    secWa.append(el('div', { class: 'flex gap-2 wrap' }, conectar),
      el('details', { class: 'mt-3' }, el('summary', { class: 'text-sm' }, 'Conectar a mano o con mi propia app de Meta'), manual));
  }
  outlet.appendChild(secWa);

  // ------------------------------------------------ el equipo por WhatsApp
  const filas = (a.equipo || []).map((p) => ({ ...p }));
  const lista = el('div', { class: 'msg-equipo' });
  const pintar = () => {
    clear(lista);
    if (!filas.length) lista.appendChild(el('p', { class: 'muted text-sm' }, 'Nadie todavía.'));
    filas.forEach((p, i) => {
      const sel = el('select', { class: 'select', 'aria-label': 'Usuario', onchange: (e) => { p.user_id = e.target.value || null; } },
        el('option', { value: '' }, 'Sin usuario'),
        ...usuarios.map((u) => { const o = el('option', { value: u.id }, u.full_name); if (u.id === p.user_id) o.selected = true; return o; }));
      lista.appendChild(el('div', { class: 'msg-fila' },
        el('input', { class: 'input', placeholder: 'Nombre', value: p.nombre || '', oninput: (e) => { p.nombre = e.target.value; } }),
        el('input', { class: 'input', placeholder: 'WhatsApp 809 555 1234', value: p.telefono || '', inputmode: 'tel', oninput: (e) => { p.telefono = e.target.value; } }),
        sel,
        el('label', { class: 'checkbox' }, el('input', { type: 'checkbox', checked: p.avisos !== false, onchange: (e) => { p.avisos = e.target.checked; } }), el('span', {}, 'Recibe avisos')),
        el('button', { class: 'btn ghost sm', type: 'button', onclick: () => { filas.splice(i, 1); pintar(); } }, 'Quitar')));
    });
  };
  pintar();
  const horaRes = el('input', { class: 'input', type: 'time', value: a.resumen_hora || '', 'aria-label': 'Hora del resumen' });
  outlet.appendChild(el('section', { class: 'card mb-4' },
    el('h3', { class: 'rp-h' }, 'Tu equipo maneja todo por WhatsApp'),
    el('p', { class: 'muted text-sm' }, 'Estas personas le escriben al WhatsApp de la empresa y el sistema les contesta: resumen del día, solicitudes, aprobar, registrar pagos, mandar factura o contrato al cliente, ver entregas y devoluciones, disponibilidad… Escribiendo "ayuda" ven todo. También reciben los avisos (solicitud nueva, contrato firmado, lo que sale y vuelve).'),
    el('p', { class: 'muted text-sm' }, 'Usa un número distinto al de la empresa (el celular personal de cada uno).'),
    lista,
    el('div', { class: 'flex gap-2 wrap mt-2' },
      el('button', { class: 'btn', type: 'button', onclick: () => { filas.push({ nombre: '', telefono: '', user_id: null, avisos: true }); pintar(); } }, '+ Agregar persona')),
    el('div', { class: 'flex gap-2 wrap mt-3 items-center' }, el('span', { class: 'text-sm' }, 'Resumen del día a las'), horaRes,
      el('span', { class: 'muted text-sm' }, '(vacío = no mandar)')),
    el('button', { class: 'btn primary mt-3', type: 'button', onclick: async () => {
      const limpias = filas.map((p) => ({ nombre: (p.nombre || '').trim(), telefono: (p.telefono || '').replace(/[^\d+]/g, ''), user_id: p.user_id || null, avisos: p.avisos !== false }))
        .filter((p) => p.telefono.replace(/\D/g, '').length >= 10);
      try {
        await Settings.bulk({
          'whatsapp.equipo': { value: limpias, description: 'Teléfonos del equipo que manejan el sistema por WhatsApp' },
          'whatsapp.resumen_hora': { value: horaRes.value || '', description: 'Hora del resumen diario al equipo ("" = no mandar)' },
        });
        ok('Equipo guardado'); recargar();
      } catch (ex) { err(ex.message); }
    } }, 'Guardar equipo')));

  // ------------------------------------------------ probar
  const paraEmail = el('input', { class: 'input', type: 'email', placeholder: 'correo@ejemplo.com', 'aria-label': 'Correo de prueba' });
  const paraWa = el('input', { class: 'input', placeholder: '809 555 1234', inputmode: 'tel', 'aria-label': 'WhatsApp de prueba' });
  const probar = async (canal, input) => {
    try { const r = await Rentals.probarMensaje({ canal, para: input.value.trim() }); ok(r.nota || 'En camino'); }
    catch (ex) { err(ex.message); }
  };
  outlet.appendChild(el('section', { class: 'card mb-4' },
    el('h3', { class: 'rp-h' }, 'Probar'),
    el('div', { class: 'flex gap-2 wrap' }, paraEmail, el('button', { class: 'btn', type: 'button', onclick: () => probar('email', paraEmail) }, 'Mandar correo de prueba')),
    el('div', { class: 'flex gap-2 wrap mt-2' }, paraWa, el('button', { class: 'btn', type: 'button', disabled: !w.conectado, onclick: () => probar('whatsapp', paraWa) }, 'Mandar WhatsApp de prueba')),
    !w.conectado ? el('p', { class: 'muted text-sm mt-2' }, 'El WhatsApp de prueba funciona cuando el número esté conectado.') : null));

  // ------------------------------------------------ últimos mensajes
  outlet.appendChild(el('section', { class: 'card mb-4', style: 'overflow-x:auto' },
    el('h3', { class: 'rp-h' }, 'Últimos mensajes'),
    cfg.ultimos.length ? el('table', { class: 'table' },
      el('thead', {}, el('tr', {}, ...['Cuándo', 'Renta', 'Para', 'Qué', 'Estado'].map((t) => el('th', {}, t)))),
      el('tbody', {}, ...cfg.ultimos.map((m) => el('tr', {},
        el('td', {}, fmt(m.created_at)),
        el('td', {}, m.rental?.code || '—'),
        el('td', {}, `${m.canal === 'email' ? '✉️' : '💬'} ${m.para}${m.destinatario === 'equipo' ? ' (equipo)' : ''}`),
        el('td', {}, m.asunto || m.evento),
        el('td', {}, el('span', { class: `badge ${COLOR[m.estado] || ''}`, title: m.error || '' }, ESTADO[m.estado] || m.estado),
          m.error && m.estado !== 'enviado' ? el('div', { class: 'muted text-sm' }, m.error) : null))))) : el('p', { class: 'muted' }, 'Todavía no sale ningún mensaje.')));
}
